import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import { Label } from 'core';

const getActionLabel = (hits, fromCheckout) => {
  if (fromCheckout) {
    return 'Go back to modify offer to see all matches';
  }
  return hits > 0 ? 'See all matches' : 'Search members';
};

// The automatic match search uses the applicant's name plus the offer's state, so a member whose
// account is in another state (e.g. a secondary home offer) comes back as 0 hits. Staff still need
// the search dialog to find and link that member, so the action shows with 0 hits too.
const PotentialMatches = ({ matchLabel, classes, fromCheckout, setMatchesResult, offerId, history, hits = 0 }) => (
  <Grid item className={hits ? classes.potentialMatches : classes.noPotentialMatches}>
    <Label className={classes.matchLabel}>{matchLabel}</Label>
    {(hits > 0 || !fromCheckout) && (
      <Label
        type="action"
        className={hits ? classes.matchAction : classes.matchAction2}
        onClick={() => {
          setMatchesResult(true);
          if (fromCheckout) {
            history.push(`/offer/${offerId}`);
          }
        }}
      >
        {getActionLabel(hits, fromCheckout)}
      </Label>
    )}
  </Grid>
);

PotentialMatches.propTypes = {
  matchLabel: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  fromCheckout: PropTypes.bool.isRequired,
  setMatchesResult: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  offerId: PropTypes.string.isRequired,
  hits: PropTypes.number
};

export default PotentialMatches;
